var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppelectricalDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5882C0 4.78925 4.70101 0 10.5 0V0C16.299 0 21 4.78925 21 10.5882V10.5882C21 16.3872 16.299 21.1765 10.5 21.1765V21.1765C4.70101 21.1765 0 16.3872 0 10.5882V10.5882Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3971 12.0049C18.3971 11.6153 18.0783 11.2966 17.6888 11.2966H16.2721V12.7132H17.6888C18.0783 12.7132 18.3971 12.3945 18.3971 12.0049Z",
    fill: "#68778D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6888 14.1299H16.2721V15.5466H17.6888C18.0783 15.5466 18.3971 15.2278 18.3971 14.8382C18.3971 14.4487 18.0783 14.1299 17.6888 14.1299Z",
    fill: "#68778D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0221 12.0049H10.6055V14.8382H12.0221C12.0221 15.6174 12.6596 16.2549 13.4388 16.2549H15.5638V10.5882H13.4388C12.6596 10.5882 12.0221 11.2257 12.0221 12.0049Z",
    fill: "#68778D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06376 11.2966C7.06376 10.5174 7.70126 9.8799 8.48043 9.8799H9.54293C10.91 9.8799 12.0221 8.76782 12.0221 7.40074C12.0221 6.03365 10.91 4.92157 9.54293 4.92157H7.06376C6.67418 4.92157 6.35543 5.24032 6.35543 5.6299C6.35543 6.01949 6.67418 6.33824 7.06376 6.33824H9.54293C10.1308 6.33824 10.6054 6.81282 10.6054 7.40074C10.6054 7.98865 10.1308 8.46324 9.54293 8.46324H8.48043C6.91501 8.46324 5.64709 9.73115 5.64709 11.2966C5.64709 12.862 6.91501 14.1299 8.48043 14.1299H9.89709V12.7132H8.48043C7.70126 12.7132 7.06376 12.0757 7.06376 11.2966Z",
    fill: "#68778D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppelectricalDone);
export default __webpack_public_path__ + "static/media/app.electrical_done.f288cea083667f8868b40d1c6ddeff20.svg";
export { ForwardRef as ReactComponent };